import { Helpers } from '../../helpers';
import { ISecurityLevel } from '../../interfaces/isecurity-level';
import { Scenario } from '../scenario';

export class SecurityLevelBase {
  SecurityLevelId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenarios_SecurityLevel?: Array<Scenario> | null;

  constructor(item?: ISecurityLevel) {
    if (item) {

      this.SecurityLevelId = item.SecurityLevelId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenarios_SecurityLevel = Helpers.createClassArray(Scenario, item.Scenarios_SecurityLevel);
    }
  }
}